import { Component } from '@angular/core';
import { BaseComponent } from '../shared/base-components/base.component';

@Component({
    selector: '[not-found]',
    templateUrl: './api-response-not-found.html'
})

export class ApiResponseNotFoundComponent extends BaseComponent {

    constructor(
    ) {
        super();

    }

    ngOnInit() {

    }
}
